

















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class UserNav extends Vue {
  public canGoBack: boolean;
  public canAdd: boolean;

  constructor() {
    super();
    this.canGoBack = false;
    this.canAdd = true;
  }

  @Watch('$route.path')
  private onRouteChanged(path: string, oldPath: string): void {
    this.canGoBack = path.match(/^(.*\/add)|(.*\/edit)$/) ? true : false;
    this.canAdd = path.includes('add') ? false : true;
  }
}
